var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleBang(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1825"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 44",
    cx: 19.5,
    cy: 19.5,
    r: 17.5,
    fill: "#CDCDCD",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "!",
    d: "M20.7626 8.89453L20.4975 24.4419H17.673L17.4078 8.89453H20.7626ZM19.0903 30.9208C18.5261 30.9208 18.0435 30.7148 17.6424 30.3028C17.2413 29.8836 17.0442 29.3793 17.051 28.7896C17.0442 28.2071 17.2413 27.7098 17.6424 27.2977C18.0435 26.8786 18.5261 26.669 19.0903 26.669C19.641 26.669 20.1168 26.8786 20.5179 27.2977C20.919 27.7098 21.1229 28.2071 21.1297 28.7896C21.1229 29.1803 21.0244 29.5391 20.834 29.8659C20.6505 30.1856 20.4057 30.4413 20.0998 30.6331C19.7939 30.8249 19.4574 30.9208 19.0903 30.9208Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleBang);
export default __webpack_public_path__ + "static/media/circleBang.8c95409c.svg";
export { ForwardRef as ReactComponent };